/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
// import { UserService } from 'src/app/core/services/user/user/user.service';
// import { environment } from 'src/environments/environment';
import { CurrencyPipe, registerLocaleData } from "@angular/common";
import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import localeDe from "@angular/common/locales/de";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment-timezone";
import { CountryISO } from "ngx-intl-tel-input";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, Subject } from "rxjs";
import { getQueryParam } from "src/app/features/liveshop/utils/helpers";
import {
  API_PATH,
  currency_symbols,
  isHappyBabyFlag,
  isJDXHomePage,
  isSRSMFlag,
  APIKEY,
  c2cEnv,
} from "src/environments/config";
import { environment } from "../../../environments/environment";
import { GeoCodeService } from "../../services/common/geocode/geo-code.service";
import { UserService } from "../../services/shared/user/user.service";
import { BusinessService } from "../business.service";
import { CscdataService } from "../common/cscdata/cscdata.service";
import { LocationService } from "../location-service/location.service";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogState,
} from "@angular/material/dialog";
import { EnableCookiesComponent } from "src/app/features/home-feature/enable-cookies/enable-cookies.component";
import Cookies from "js-cookie";
import { OrderByPipe } from "valuchaincommon/shared-components/order-by/order-by.pipe";

const setActualDimensions = () => {
  const windowHeight = window.innerHeight * 0.01;
  const windowWidth = window.innerWidth * 0.01;
  document.documentElement.style.setProperty("--vh", `${windowHeight}px`);
  document.documentElement.style.setProperty("--vw", `${windowWidth}px`);
  return { windowHeight, windowWidth };
};

registerLocaleData(localeDe, "de");
@Injectable({
  providedIn: "root",
})
export class SlotService {
  URL = {
    testPath: "/inventories/createInventoryMaster",
    daySlotMaster: "/daySlotMaster",
    slotmaster: "/slotmaster",
    calenderSlotMaster: "/calenderSlotMaster",
    listProductCategories: "/listProductCategories",
    businessUsers: "/businessUsers",
    daySlotMasterMassUpdate: "/daySlotMasterMassUpdate",
    slotMasterMassUpdate: "/slotMasterMassUpdate",
    appointment: "/appointment",
    contacts: "/contacts",
    getAppointments: "/appointments",
    getSlotMasterDetails: "/getAppointmentData",
    getAppointmentSalesperson: "/getAppointmentSalesperson",
    cloneDaySlotMaster: "/cloneDaySlotMaster",
    createOrder: "/couponTransaction",
    coupon: "/coupon",
    checkCouponTransaction: "/checkCouponTransaction",
    storeInventoryGroup: "/getInventoryAggregate",
    getInventoryProductCategories: "/getDistinctCategories",
    productDetails: "/scanValuTrace",
    getLayerDetails: "/getTextures",
    getMaterialDetails: "/getMaterialsList",
    getTextureDetails: "/getTextureDetails",
    getStory: "/stories",
    createAppointmentOrder: "/createAppointmentOrder",
    getShippingCharges: "/orderShippingCharges",
    getAppointmentsOrders: "/getAppointmentsOrders",
    getItemMasters: "/itemmastergroup",
    getDistinctItemMasterCategories: "/getDistinctItemMasterCategories",
    segments: "/companysegments",
    companysegmentCategories: "/companysegmentCategories",
    unitofmeasures: "/unitofmeasures",
    itemmastergroupwhiteshop: "/itemmastergroupwhiteshop",
    updateappointmentproducts: "/updateappointmentproducts",
    getItemMasterGroupById: "/getitemmastersbygroup/",
    salesperson: "/getSalesperson",
    appointmentSalesperson: "/getAppointmentSalesperson",
    appointmentCategories: "/getAppointmentCategories",
    spotBooking: "/spotBooking",
    spotBookingB2C: "/spotBookingB2C",
    contactByMailID: "/contactByMailID",
    getBusinessUnitCategories: "/getBusinessUnitCategories",
    getAppointmentsReport: "/getAppointmentsReport",
    getProductsOfCategories: "/inventories/matchedinventories",
    createOffer: "/offers",
    getOffersInventory: "/offers",
    externalOffer: "/externalOffer",
    collectionGroupSet: "/inventorygroupsets",
    boardDetails: "/proofurl",
    createBoard: "/inventorygroupsets",
    inventoryGroupsGroupActions: "/inventorygroupgroupactions",
    inventoryGroupSetOrder: "/inventorygroupsets",
    offerLink: "/orderlink",
    offerLinkCode: "/order-link",
    sendResendLink: "/sendorderlink",
    currentUser: "/users/me",
    getArchiveProducts: "/getarchiveproducts",
    updateInventoryGroup: "/inventorygroup/",
    orderLinkData: "/orderlinkdata",
    itemMasterPriceByItemMasterGroup: "/itemmasterpricebyitemmastergroup",
    businessUnitCollections: "/businessunitcollectioninventorygroups",
    appointmentboards: "/appointmentboards",
    inventorygroups: "/inventorygroups",
    getInventories: "/getInventories",
    getGroupsData: "/getGroupsData",
    division: "/division",
    appointmentgroup: "/appointmentgroup",
    getInventorySnapshop: "/getInventorySnapshop",
    getAppointmentReport: "/getAppointmentReport",
    busUnitInventories: "/busUnitInventories",
    inventoryGroupCount: "/inventorygroupcount",
    createExcelOrder: "/createExcelReport",
    deleteOrderLink: "/deleteOrderLink",
    changeOrderLinkStatus: "/changeOrderLinkStatus",
    dashboardReport: "/getDashboardReport",
    checkLinkData: "/checkLinkData",
    updateAppointmentUser: "/updateAppointmentUser",
    getLandingPageData: "/getLandingPageData",
    getUserCartData: "/getUserCartData",
    shortLink: "/urlCode",
    appointmentProducts: "/appointmentProducts",
    allWishlist: "/allwishlist",
    orderInvoice: "/invoiceOrder",
    taxGroupsList: "/taxSearch",
    taxCodesList: "/taxCodes",
    hsnCodesLits: "/hsncodeSearch",
    reasons: "/reasons",
    shareWith: "/shareWithContacts",
    shareOrderLink: "/shareOrderLink",
    notifications: "/notificationsByUser",
    clearNotifications: "/notificationsclear",
    instantProducts: "/instantproducts",
    updateNotifications: "/notifications/",
    wishlists: "/wishlists",
    getInventoriesByInventoryGroup: "/getInventoriesByInventoryGroup",
    getOrderLinksSummary: "/getsummary",
    instagramToken: "/instagramToken",
    createInstagramMedia: "/createInstagramMedia",
    getFacebookImg: "/getFacebookImg",
    exportData: "/getData",
    timetracker: "/timetracker",
    getTexturesByCompany: "/getTexturesByCompany",
    getInventoryGroupTextures: "/getInventoryGroupTextures",
    updateTextures: "/updateTextures",
    addTextures: "/addMaterialMaster",
    getMaterialMasterList: "/getMaterialMasterList",
    getMaterialData: "/getMaterialMastersByCompany",
    updateMaterialMaster: "/updateMaterialMaster",
    addRequest: "/addRequest",
    getRequest: "/getRequest",
    updateRequest: "/updateRequest",
    submitRequest: "/submitRequest",
    verifyUserCredintial: "/verifyUserCredintial",
    resendOtp: "/otpResend",
    getComponents: "/getComponents",
    appointmentStatus: "/appointmentStatus",
    getMyIp: "/myIp",
  };
  activateMobileAR: BehaviorSubject<boolean> = new BehaviorSubject(false);
  storyObject = new BehaviorSubject<any>({});
  throwLoginCheckFlag: BehaviorSubject<boolean> = new BehaviorSubject(false);
  newProductCreated: BehaviorSubject<boolean> = new BehaviorSubject(false);
  unsavedMaterials: BehaviorSubject<any> = new BehaviorSubject([]);
  profileUpdated: BehaviorSubject<any> = new BehaviorSubject(false);
  public backFromBoards: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public threedUserForm: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public businessUnitUpdated: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public detachChangeListeners: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public threeDTour = new BehaviorSubject<any>([]);
  public reasons;
  public reasonsRetailer;
  public boardLength = new BehaviorSubject<any>([]);
  public ctcCuratedProducts = [];
  public sizeInCartItems = {};
  public isCartOpened = false;
  public cartCount;
  public cartData = [];
  public appointmentCode;
  public sortCriteria;
  public isSelectedProduct;
  public isSelectedTimeSlot = false;
  public isDeletedAppointments = false;
  public selectedAddressIndex = -1;
  isHeaderAndFooter = false;
  windowHeight: number;
  windowWidth: number;
  currentPromoLinkData;
  slotDetailedViewParams;
  isUserLoggedIn = new BehaviorSubject(false);
  totalItems = [];
  isFooterEnabled = false;
  openCustomiseOptions = false;
  enlarged3DMobileView = false;
  public splitScreenClicked: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  updateColorSizeData = new BehaviorSubject<any>({});
  selectedCountry = new BehaviorSubject<any>(false);
  openOrder = new BehaviorSubject<any>("");
  openOrderOb = this.openOrder.asObservable();
  onBoardChange: BehaviorSubject<any> = new BehaviorSubject(false);
  public peformActions: BehaviorSubject<any> = new BehaviorSubject(false);
  public onLogoClicked: BehaviorSubject<any> = new BehaviorSubject(false);
  prodServerUrl = environment.server;
  public slotMasterDetailObject = {
    fromTime: "",
    toTime: "",
    slotMaster: "",
    date: "",
  };
  public isBoardFilter;
  public currentSlotMaster;
  public currentBusinessUnit;
  public selectedSlotData = {
    selectedDate: new Date(),
    selectedBusinessUnit: {},
  };
  public summary = {};
  public booking;
  public isCustomerBooking = false;
  public slotCustomerBooking;
  public slotCustomerBookingDate;
  public selectedBusinessUnit;
  public appointmentsView = "thumbnailView";
  public currentTab;
  public cart = [];
  public wishList: Array<{
    id: string;
    virtualProductConfigurations: Array<string>;
  }> = [];
  public isSpotB2B = false;
  public selectedCollection;
  public collectionsList = [];
  public landingPageCollectionsList = [];
  public selectedCollectionID;
  public selectedCollectionIndex = 1;
  isArchiveRefresh = false;
  public boardsList = [];
  public isUserInteractionDone = false;
  public isOrderLinkCreated = false;
  public addLookEdit = false;
  public isUsersActivated = false;
  public isPanoramaLoaded = false;
  public entered3DBoard = false;
  public isTDLoaded = false;
  public isThreeDEntered = false;
  public userFormWaitTimeVS = 10;
  public askMeLaterWaitTimeVS = 60;
  public userFormSkipEnabled;
  public userFormDisabled = false;
  public userDetailsFormCount = 0;
  public userDetailsFormSubmitted = false;
  public showUserDetailsForm = false;
  public is3dBoardLoading = false;
  stlImageLoaded = false;
  isSTLPromolink = false;
  isExcelDownload = false;
  excelData;
  progressReport;
  salesPersonId;
  secondarySalePerson;
  tertiarySalePerson;
  selectedBoard;
  isCustomized = false;
  selectedCategory;
  isEmbedded = false;
  presentCollection = [];
  divisions = [];
  instantProductsCart;
  httpWithoutInterceptor: HttpClient;
  public hideParticipants = true;
  rectangleSetting = false;
  isInstructionsShown = false;
  boardEditIndex = -1;
  detailedViewOpened = false;
  instantProductsData = [];
  unusedTypes = [
    "audio",
    "pip-video",
    "3d-video",
    "Video",
    "videoFrame",
    "East",
    "West",
    "North",
    "South",
    "NorthEast",
    "NorthWest",
    "SouthEast",
    "SouthWest",
    "Room",
    "floorPlan",
  ];
  url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=";
  api = APIKEY.googleMapsAPIKEY;
  geoCodeData: any;
  ipAddressData: any;
  fromSocialLink;
  isPlayAudio3D = false;
  whatsAppNumber;
  stlIndex;
  audioVolume = 0.4;
  vidCollectionVolume = 0.4;
  playAudio = true;
  audioFileURL = "";
  isAudioPaused;
  is3DBoard;
  resetStlCategories = false;
  productAddedInPos = false;
  currCountryCode;
  sellerCode;
  sellerCurrency;
  currCountry = {
    code: "",
    currency: "",
    rate: 1,
  };
  currSymbol;
  getIPUrl = "https://api4.ipify.org?format=json";
  orderLinkCode;
  primaryThemeColor = "#28a4dd";
  primaryFont = "Poppins";
  inProgressLinks = [];
  shortLinks = {};
  promoLinkUsername: any;
  businessUnitPageScroll;
  presentTimeZone;
  isCartChanged = false;
  public c2cKey;
  public c2cUserName;
  userInactivityThreshold = 180000;
  instantProductComments = {};
  showActiveLinks = false;
  pdpDialogRef: any;
  loginConsumerDialog;
  public divisionsCallCount = 0;
  public appointmentCallCount = 0;
  public stlFilterCount = 0;
  orderLinkOwner;
  interactiveDetailedDialogRef: any;
  similarDialogRef: any;
  threeSixtyDialog: any;
  currCountryName;
  is3DFullScreen = false;
  roomPlanViewMode;
  allRoomItemsHidden: boolean = false;
  isRidhiMehra =
    window.location.href.includes("ridhimehra") ||
    window.location.href.includes("rmsales");
  fontFamilies = [
    "Futura-Pt",
    "Lato",
    "Montserrat",
    "Mulish",
    "Myriad-Pro",
    "Noto Sans",
    "Nunito",
    "Open Sans",
    "PT Sans",
    "Helvetica",
    "Poppins",
    "Proxima-Nova",
    "Raleway",
    "Source Sans Pro",
    "Tablet-Gothic",
    "Ubuntu",
    "Work Sans",
  ];
  hideIconsInFullScreen = false;
  openWidgetInPromolink = false;
  configuratorView = false;
  websitePromolinkCB;
  selectedSubCategory;
  boardGroup;
  boardNavigationChar = "/";
  boardGroupList;
  configuratorPrice;
  similarProductsCurrentProductId;
  unitofMeasure;
  secondaryCustomer = false;
  constructor(
    private http: HttpClient,
    private currencyPipe: CurrencyPipe,
    public userService: UserService,
    private router: Router,
    private httpBackend: HttpBackend,
    public locationService: LocationService,
    public businessService: BusinessService,
    public geoCodeService: GeoCodeService,
    public toastrService: ToastrService,
    public cscData: CscdataService,
    public dialog: MatDialog
  ) {
    this.httpWithoutInterceptor = new HttpClient(httpBackend);
    try {
      localStorage.getItem("blockUser");
      if (!localStorage) {
        this.enableCookies();
      }
    } catch (e) {
      this.enableCookies();
    }
    this.setCurrencyObject();
  }
  setCurrencyObject() {
    let currenctUnit = JSON.parse(
      sessionStorage.getItem("currentBusinessUnit")
    );
    if (currenctUnit && currenctUnit.currency) {
      if (currenctUnit.address?.country) {
        this.sellerCode =
          CountryISO[currenctUnit.address.country.replace(/\s/g, "")];
      } else if (currenctUnit.addresses?.length > 0) {
        this.sellerCode =
          CountryISO[currenctUnit.addresses[0].country.replace(/\s/g, "")];
      }
      this.sellerCurrency = currenctUnit.currency;
      this.currCountry = {
        code: this.sellerCode,
        currency: this.sellerCurrency,
        rate: 1,
      };
      this.currSymbol = currency_symbols[this.currCountry.currency];
    }
  }
  getBuyerLocale() {
    let localTime = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.cscData
      .getCSCdata(false, true, this.sellerCurrency, localTime)
      .subscribe((res) => {
        this.currCountry = res;
        this.currSymbol = currency_symbols[res.currency];
      });
  }
  getFormattedCurrency(value, rate?, currency?) {
    value = value || 0;
    currency = currency ? currency : this.currCountry.currency;
    const isSymbolRight = currency === "EUR" ? "de" : null;
    const symbol = currency_symbols[currency];
    value = value ? parseFloat((Math.round(value * 100) / 100).toFixed(2)) : 0;
    value /= rate ? rate : this.currCountry.rate;
    let displayFormat;
    if (currency === "INR") {
      displayFormat = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: currency,
      }).format(value);
    } else {
      displayFormat = this.currencyPipe.transform(
        value,
        currency,
        symbol,
        "0.2-2",
        isSymbolRight
      );
      if (!["EUR", "GBP", "USD", "INR"].includes(currency)) {
        displayFormat = displayFormat.replace(/,/g, "");
      }
    }
    return String(displayFormat);
  }
  getCountryObjectByBusinessUnit(isDefault?) {
    let unitRef;
    if (isDefault) {
      const bUnits = JSON.parse(localStorage.getItem("businessUnits"));
      if (bUnits) {
        unitRef = bUnits.filter((unit) => {
          if (unit.defaultBusinessUnit) {
            return unit.businessUnit;
          }
        })[0]?.businessUnit;
      }
    }
    if (!unitRef) {
      unitRef = JSON.parse(sessionStorage.getItem("currentBusinessUnit"));
    }
    if (unitRef?.address?.country) {
      return {
        country: unitRef.address.country,
        isoCode: CountryISO[unitRef.address.country.replace(/\s/g, "")],
      };
    } else {
      return false;
    }
  }
  checkIscustomized() {
    this.isCustomized = location.href.includes("isCustomized");
  }
  getCountryCode() {
    return new Promise((resolve) => {
      this.getIpAddress().subscribe(
        async (ipAddressData) => {
          let geoCodeData;
          if (
            !(
              localStorage.getItem("user") &&
              localStorage.getItem("retailerToken")
            )
          ) {
            geoCodeData = await this.geoCodeService.trackme();
            if (geoCodeData) {
              resolve(geoCodeData["country"]);
            }
          }
          if (!geoCodeData) {
            this.geoCodeService.getAddressFromIP(ipAddressData.ip).subscribe(
              (res) => {
                resolve(res["country"]);
              },
              (err) => {}
            );
          }
        },
        (err) => {}
      );
    });
  }
  testPathCall(data?) {
    data["type"] = "whiteShop";
    return this.http.post<any>(this.prodServerUrl + this.URL.testPath, data);
  }
  getTaxList() {
    return this.http.get<any>(this.prodServerUrl + this.URL.taxGroupsList);
  }

  getTaxCodes() {
    return this.http.get<any>(this.prodServerUrl + this.URL.taxCodesList);
  }

  getHsnCodesList() {
    return this.http.get<any>(this.prodServerUrl + this.URL.hsnCodesLits);
  }
  getDaySlotMasters(businessUnitId?) {
    let httpParams = new HttpParams();
    if (businessUnitId) {
      httpParams = httpParams.set("businessUnitId", businessUnitId);
    } else {
      httpParams = httpParams.set(
        "businessUnitId",
        this.userService.currentBusinessUnitId
      );
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.daySlotMaster, {
      params: httpParams,
    });
  }

  createDaySlotMaster(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.daySlotMaster,
      data
    );
  }

  createSlotMaster(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.slotmaster, data);
  }

  getProductCategories() {
    return this.http.get<any>(
      this.prodServerUrl + this.URL.listProductCategories
    );
  }
  getAppointmentCategories(businessunit) {
    let httpParams = new HttpParams().set("businessUnitId", businessunit);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.appointmentCategories,
      { params: httpParams }
    );
  }

  getCloneItemMasters(itemMasterId) {
    const httpParams = new HttpParams().set("inventoryGroup", itemMasterId);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.itemMasterPriceByItemMasterGroup,
      { params: httpParams }
    );
  }

  getAppointmentStatus(code) {
    const httpParams = new HttpParams().set("code", code);
    return this.http.get<any>(this.prodServerUrl + this.URL.appointmentStatus, {
      params: httpParams,
    });
  }

  getItemMasterGroups(bUnitId) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("businessUnitId", bUnitId);
    httpParams = httpParams.set("isWhiteShop", "true");
    return this.http.get<any>(this.prodServerUrl + this.URL.getItemMasters, {
      params: httpParams,
    });
  }

  getDistinctItemMasterCategories(bUnitId) {
    let httpParams = new HttpParams();
    // httpParams = httpParams.set('businessUnit', bUnitId);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getDistinctItemMasterCategories,
      { params: httpParams }
    );
  }

  getBusinessUsers() {
    return this.http.get<any>(this.prodServerUrl + this.URL.businessUsers);
  }
  createAppointmentOrder(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.createAppointmentOrder,
      data
    );
  }
  getShippingRates(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.getShippingCharges,
      data
    );
  }
  getAppointmentsOrders() {
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getAppointmentsOrders
    );
  }
  getBoostLinkData(code, boardTypeName?) {
    var httpParams = new HttpParams();
    httpParams = httpParams.set("linkCode", code);
    if (boardTypeName) {
      httpParams = httpParams.set("boardTypeName", boardTypeName);
    }
    return this.http.get(this.prodServerUrl + "/order-link", {
      params: httpParams,
    });
  }

  stringDateFormat(date?) {
    let givenDate;
    if (date) {
      givenDate = date;
    } else {
      givenDate = new Date();
    }
    const today = new Date(givenDate);
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  }

  getCalenderDaySlotMasters(
    bUnitId,
    fromDate,
    toDate,
    status?,
    isSummery?,
    salespersons?,
    isHomePage?,
    deleted?
  ) {
    if (!salespersons || isHomePage) {
      if (bUnitId) {
        let httpParams = new HttpParams();
        httpParams = httpParams.set("businessUnitId", bUnitId);
        if (fromDate) {
          httpParams = httpParams.set(
            "fromDate",
            this.stringDateFormat(fromDate).toString()
          );
          httpParams = httpParams.set(
            "toDate",
            this.stringDateFormat(toDate).toString()
          );
        } else {
          httpParams = httpParams.set("isToday", "true");
        }
        if (status) {
          httpParams = httpParams.set("isStatus", status);
        }
        if (isSummery) {
          httpParams = httpParams.set("isSummery", "true");
        }
        if (deleted) {
          httpParams = httpParams.set("deleted", "true");
        }
        let urlSales = "?";
        if (salespersons) {
          salespersons.forEach((element) => {
            urlSales += "&salesPersons[]=" + element;
            // httpParams = httpParams.set('salesPersons[]', element )
          });
        }
        if (isHomePage) {
          httpParams = httpParams.set("isHomePage", isHomePage);
        }
        console.log(httpParams);
        if (urlSales.length > 1) {
          return this.http.get<any>(
            this.prodServerUrl + this.URL.getAppointments + urlSales,
            { params: httpParams }
          );
        }
        return this.http.get<any>(
          this.prodServerUrl + this.URL.getAppointments,
          { params: httpParams }
        );
      }
    } else {
      let url =
        "?businessUnitId=" +
        bUnitId +
        "&fromDate=" +
        this.stringDateFormat(fromDate).toString() +
        "&toDate=" +
        this.stringDateFormat(toDate).toString();
      if (status) {
        url += "&isStatus=" + status;
      }
      if (isSummery) {
        url += "&isSummery=" + true;
      }
      if (deleted) {
        url += "&deleted=" + true;
      }
      return this.http.post<any>(
        this.prodServerUrl + this.URL.getAppointmentSalesperson + url,
        { salespersons: salespersons }
      );
    }
  }

  appointmentReports(bUnitId, fromDate, toDate, salespersons?) {
    if (bUnitId) {
      let httpParams = new HttpParams();
      httpParams = httpParams.set("businessUnitId", bUnitId);
      if (fromDate) {
        httpParams = httpParams.set("fromDate", fromDate);
        httpParams = httpParams.set("toDate", toDate);
      } else {
        httpParams = httpParams.set("isToday", "true");
      }
      let urlSales = "?";
      if (salespersons) {
        salespersons.forEach((element) => {
          urlSales += "&salesPersons[]=" + element;
          // httpParams = httpParams.set('salesPersons[]', element )
        });
      }
      console.log(httpParams);
      if (urlSales.length > 1) {
        return this.http.get<any>(
          this.prodServerUrl + this.URL.getAppointmentsReport + urlSales,
          { params: httpParams }
        );
      }
      return this.http.get<any>(
        this.prodServerUrl + this.URL.getAppointmentsReport,
        { params: httpParams }
      );
    }
  }

  createCalenderDaySlotMaster(data) {
    if (!data.businessUnitId) {
      data["businessUnitId"] = this.userService.currentBusinessUnitId;
    }
    return this.http.post<any>(
      this.prodServerUrl + this.URL.calenderSlotMaster,
      data
    );
  }

  updateDaySlotMaster(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.daySlotMaster,
      data
    );
  }

  updateInventoryGroup(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateInventoryGroup + data._id,
      data
    );
  }

  getBusinessUnitCategories(
    businessUnitId?,
    isCatalog?,
    isCount?,
    isArchive?,
    is360Degree?,
    hasProductVideo?,
    isRoomPlan?
  ) {
    let httpParams = new HttpParams();
    if (businessUnitId) {
      httpParams = httpParams.set("businessUnitId", businessUnitId);
    }
    if (isCatalog) {
      httpParams = httpParams.set("type", "itemMater");
    }
    if (isCount) {
      httpParams = httpParams.set("count", "true");
    }
    if (isArchive) {
      httpParams = httpParams.set("archive", "true");
    }
    if (is360Degree) {
      httpParams = httpParams.set("is360Degree", "true");
    }
    if (hasProductVideo) {
      httpParams = httpParams.set("hasProductVideo", "true");
    }
    if (isRoomPlan) {
      httpParams = httpParams.set("isRoomPlan", "true");
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getBusinessUnitCategories,
      { params: httpParams }
    );
  }
  massUpdateDaySlotMaster(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.daySlotMasterMassUpdate,
      data
    );
  }

  updateSlotMaster(data) {
    return this.http.put<any>(this.prodServerUrl + this.URL.slotmaster, data);
  }
  massUpdateSlotMaster(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.slotMasterMassUpdate,
      data
    );
  }

  createAppointment(data) {
    data["businessUnitId"] = this.userService.currentBusinessUnitId;
    return this.http.post<any>(
      this.prodServerUrl + this.URL.getAppointments,
      data
    );
  }

  createContact(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.contacts, data);
  }

  getSlotMasterDetails(data) {
    let httpParams = new HttpParams();
    if (data._id) {
      console.log(data);
      httpParams = httpParams.set("date", data.date);
      httpParams = httpParams.set("slotMasterId", data._id);
      httpParams = httpParams.set("fromTime", data.fromTime);
      httpParams = httpParams.set("toTime", data.toTime);
    } else if (data.spotBookingId && data.spotBookingId !== "groupView") {
      httpParams = httpParams.set("appointmentId", data.spotBookingId);
    } else {
      httpParams = httpParams.set("date", data.date);
      httpParams = httpParams.set("fromTime", data.fromTime);
      httpParams = httpParams.set("toTime", data.toTime);
      if (data.divisionId) {
        httpParams = httpParams.set("divisionId", data.divisionId);
      }
    }
    if (data.businessUnit) {
      httpParams = httpParams.set("businessUnit", data.businessUnit);
    }
    if (
      localStorage.getItem("consumerData") &&
      JSON.parse(localStorage.getItem("consumerData"))?.owner?.company
    ) {
      httpParams = httpParams.set(
        "company",
        JSON.parse(localStorage.getItem("consumerData")).owner.company
      );
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getSlotMasterDetails,
      { params: httpParams }
    );
  }

  getInventoryProductCategories(data, isItemMaster?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("businessUnit", data);
    if (isItemMaster) {
      httpParams = httpParams.set("isItemMaster", "true");
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getInventoryProductCategories,
      { params: httpParams }
    );
  }

  getBookedAppointments(data) {
    console.log(data);
    let httpParams = new HttpParams();
    httpParams = httpParams.set(
      "businessUnitId",
      this.userService.currentBusinessUnitId
    );
    httpParams = httpParams.set("fromDate", data.fromDate);
    httpParams = httpParams.set("toDate", data.toDate);
    httpParams = httpParams.set("isBooked", "true");
    httpParams = httpParams.set("type", "valuChain");
    return this.http.get<any>(this.prodServerUrl + this.URL.appointment, {
      params: httpParams,
    });
  }
  cloneSlots(daySlotMasterId) {
    const httpParams = new HttpParams().set("_id", daySlotMasterId.toString());
    return this.http.get<any>(
      this.prodServerUrl + this.URL.cloneDaySlotMaster,
      { params: httpParams }
    );
  }

  getSummeryData(bUnit, from, to) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("businessUnitId", bUnit);
    httpParams = httpParams.set("fromDate", from);
    httpParams = httpParams.set("toDate", to);
    httpParams = httpParams.set("isSummary", "true");
    return this.http.get<any>(this.prodServerUrl + this.URL.appointment, {
      params: httpParams,
    });
  }

  uploadBackgroundImage(data) {
    return this.http.put<any>(this.prodServerUrl + this.URL.appointment, data);
  }

  createOrder(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.createOrder, data);
  }

  verifyCoupon(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("coupon", data);
    return this.http.get<any>(this.prodServerUrl + this.URL.coupon, {
      params: httpParams,
    });
  }

  checkCouponTransaction(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("appointment", data);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.checkCouponTransaction,
      { params: httpParams }
    );
  }
  findUserType(data): String {
    const userId = localStorage.getItem("nVipaniwhiteshopUser");
    let userType = "user";

    if (
      data.details.salesperson &&
      data.details.salesperson.username === userId
    ) {
      userType = "Sales Person";
    } else if (
      data.details.inCharge &&
      data.details.inCharge.username === userId
    ) {
      userType = "In Charge";
    } else {
      userType = "user";
    }
    return userType;
  }

  joinNow(appointmentData, division?) {
    if (!division) {
      const { user } = appointmentData.booking;

      if (this.findUserType(appointmentData) !== "user") {
        this.router.navigate(["/liveshop"], {
          queryParams: {
            shopkeeper: true,
            code: appointmentData.code,
            ctc: true,
          },
        });
      } else if (this.isSpotB2B) {
        this.router.navigate(["/liveshop"], {
          queryParams: {
            spot: true,
            code: appointmentData.code,
            ctc: true,
          },
        });
      } else {
        this.router.navigate(["/liveshop"], {
          queryParams: {
            code: appointmentData.code,
          },
        });
      }
    } else {
      this.router.navigate(["/liveshop"], {
        queryParams: {
          shopkeeper: true,
          code: appointmentData.code,
        },
      });
    }
  }

  getInventoryGroupData(object) {
    let params1 = new HttpParams();
    if (object.isInventoryGroup) {
      params1 = params1.set("isInventoryGroup", object.isInventoryGroup);
    }
    if (object.isRoomPlaner) {
      params1 = params1.set("isRoomPlaner", object.isRoomPlaner);
    }
    if (object.currentBusinessUnit) {
      params1 = params1.set("businessUnitId", object.currentBusinessUnit);
    }
    if (object.inventoryGroup) {
      params1 = params1.set("inventoryGroup", object.inventoryGroup);
    }
    if (object.isInSeason) {
      params1 = params1.set("iscount", "true");
      let params = new HttpParams().set(
        "busUnitId",
        object.businessUnit ? object.businessUnit : this.currentBusinessUnit._id
      );
      if (object.inventoryGroup) {
        params = params.set("inventoryGroupId", object.inventoryGroup);
      }
      return this.http.get<any>(
        this.prodServerUrl + this.URL.inventoryGroupCount,
        {
          params: params,
        }
      );
    }
    if (object.page) {
      params1 = params1.set("page", object.page).set("limit", object.limit);
    }
    if (object.search) {
      params1 = params1.set("searchText", object.search);
    }
    if (object.sortField) {
      params1 = params1.set("sortField", object.sortField);
    }
    // if (object.isCategory) {
    params1 = params1.set("iscategory", "true");
    // }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.storeInventoryGroup,
      { params: params1 }
    );
  }
  getInventoryGroupsCustomer(businessUnit, email, company, page?, limit?) {
    let params1 = new HttpParams();
    if (businessUnit) {
      params1 = params1.set("busUnitId", businessUnit.toString());
    }
    if (page) {
      params1 = params1.set("page", page.toString());
      params1 = params1.set("limit", limit.toString());
    }
    return this.http.post<any>(
      this.prodServerUrl + this.URL.inventorygroups,
      { email: email, company: company },
      {
        params: params1,
      }
    );
  }

  getInventoryGroups(businessUnit, page?, limit?) {
    let params1 = new HttpParams();
    if (businessUnit) {
      params1 = params1.set("busUnitId", businessUnit.toString());
    }
    if (page) {
      params1 = params1.set("page", page.toString());
      params1 = params1.set("limit", limit.toString());
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.inventorygroups, {
      params: params1,
    });
  }

  getArchiveProducts(bUnitId) {
    let params1 = new HttpParams();
    params1 = bUnitId ? params1.set("businessUnitId", bUnitId) : params1;
    params1 = params1.set("isCategory", "true");
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getArchiveProducts,
      { params: params1 }
    );
  }

  fetchProduct(
    requestDataObject,
    flag?,
    collection?,
    isPDP?,
    isColors?,
    isSimilar?,
    getInformation?
  ) {
    let params = new HttpParams();
    params = requestDataObject.sequence
      ? params.set("sequence", requestDataObject.sequence)
      : params;
    if (collection) {
      params = params.set("isCollection", "true");
    }
    if (isPDP) {
      params = params.set("isPDP", "true");
    }
    if (getInformation) {
      params = params.set("getInformation", "true");
    }
    if (isColors) {
      params = params.set("isRelatedProducts", "false");
    } else if (isSimilar) {
      params = params.set("isRelatedProducts", "true");
      params = params.set("targetAttribute", "similar");
    }
    params = requestDataObject.inventoryGroupId
      ? params.set("inventoryGroupId", requestDataObject.inventoryGroupId)
      : params;
    return this.http.get<any>(this.prodServerUrl + this.URL.productDetails, {
      params: params,
    });
  }
  fetchColorData(productID, layerName, materialName?) {
    let params = new HttpParams();
    if (productID) {
      params = params.set("inventoryGroupId", productID);
    }
    if (layerName) {
      params = params.set("layerName", layerName);
    }
    if (materialName) {
      params = params.set("materialName", materialName);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.getLayerDetails, {
      params: params,
    });
  }
  fetchMaterialData(productID, layerName) {
    let params = new HttpParams();
    if (productID) {
      params = params.set("inventoryGroupId", productID);
    }
    if (layerName) {
      params = params.set("layerName", layerName);
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getMaterialDetails,
      {
        params: params,
      }
    );
  }
  fetchTextureDetails(colorsRequired) {
    let params = new HttpParams();
    if (colorsRequired) {
      params = params.set("layers", JSON.stringify(colorsRequired));
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.getTextureDetails, {
      params: params,
    });
  }
  fetchthreedProductDetails(
    layerName,
    inventoryGroup?,
    businessUnitId?,
    isSetup?
  ) {
    let params = new HttpParams();
    if (layerName) {
      params = params.set("layerName", layerName);
    }
    if (inventoryGroup) {
      params = params.set("inventoryGroup", inventoryGroup);
    }
    if (isSetup) {
      params = params.set("isSetup", isSetup);
    }
    console.log(params);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getTexturesByCompany,
      {
        params: params,
      }
    );
  }

  fetchInventoryGroupTextures(inventoryGroup) {
    let params = new HttpParams();
    params = params.set("inventoryGroupId", inventoryGroup);
    console.log(params);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getInventoryGroupTextures,
      {
        params: params,
      }
    );
  }

  updateTextures(
    businessUnit?,
    inventoryGroup?,
    textureObject?,
    deleteInventoryGroupId?
  ) {
    let data = {};
    if (deleteInventoryGroupId) {
      data = {
        deleteInventoryGroupId,
      };
    }
    if (textureObject) {
      data = {
        businessUnit,
        inventoryGroup,
        textureObject,
      };
    }
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateTextures,
      data
    );
  }
  addTextures(name, URL, typeName, materialName) {
    let params = new HttpParams();
    if (name) {
      params = params.set("name", name);
    }
    if (URL) {
      params = params.set("URL", URL);
    }
    if (typeName) {
      params = params.set("typeName", typeName);
    }
    if (materialName) {
      params = params.set("materialName", materialName);
    }
    return this.http.post<any>(
      this.prodServerUrl + this.URL.addTextures,
      params
    );
  }
  addRoomPlanerRequest(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.addRequest, data);
  }
  updateRoomPlanerRequest(newStatus, id) {
    let data = {
      newStatus,
      id,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateRequest + "/" + id,
      data
    );
  }
  submitRequest(data, id) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.submitRequest + "/" + id,
      data
    );
  }
  verifyRoomPlannerCredentials(data, id) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.verifyUserCredintial + "/" + id,
      data
    );
  }
  resendRoomPlannerOtp(data, id) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.resendOtp + "/" + id,
      data
    );
  }
  getMaterialList(fromMaterialMaster?) {
    let params = new HttpParams();
    params = params.set("getMaterialsList", "true");
    if (fromMaterialMaster) {
      params = params.set("fromMaterialMaster", "true");
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.getMaterialData, {
      params: params,
    });
  }
  getMaterialData(materialName?) {
    let params = new HttpParams();
    if (materialName) {
      params = params.set("materialName", materialName);
    }
    params = params.set("getMaterialsList", "false");
    return this.http.get<any>(this.prodServerUrl + this.URL.getMaterialData, {
      params: params,
    });
  }
  updateMaterialName(materialName, newMaterialName) {
    let data = {
      materialName,
      newMaterialName,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  deleteMaterial(materialName, deleteMaterials) {
    let data = {
      materialName,
      deleteMaterials,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  editTexture(textureId, updatedTextureFields) {
    let data = {
      textureId,
      updatedTextureFields,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  deleteTextures(deleteMaterials, deletedList) {
    let data = {
      deleteMaterials,
      deletedList,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  updateTexture(textureId, updatedTextureFields) {
    let data = {
      textureId,
      updatedTextureFields,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  editClass(materialName, className, newClassName) {
    let data = {
      materialName,
      className,
      newClassName,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  deleteClass(materialName, className, deleteClassName) {
    let data = {
      materialName,
      className,
      deleteClassName,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  editCollection(materialName, typeName, newTypeName) {
    let data = {
      materialName,
      typeName,
      newTypeName,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  deleteCollection(materialName, typeName, deleteMaterials) {
    let data = {
      materialName,
      typeName,
      deleteMaterials,
    };
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateMaterialMaster,
      data
    );
  }
  fetchProductWoInterceptor(
    requestDataObject,
    flag?,
    collection?,
    isPDP?,
    isColors?,
    isSimilar?,
    getInformation?
  ) {
    let params = new HttpParams();
    params = requestDataObject.sequence
      ? params.set("sequence", requestDataObject.sequence)
      : params;
    params = params.set("isRelatedProducts", flag ? flag : "true");
    if (collection) {
      params = params.set("isCollection", "true");
    }
    if (isPDP) {
      params = params.set("isPDP", "true");
    }
    if (getInformation) {
      params = params.set("getInformation", "true");
    }
    if (isColors) {
      params = params.set("isRelatedProducts", "false");
    } else if (isSimilar) {
      params = params.set("isRelatedProducts", "true");
      params = params.set("targetAttribute", "similar");
    }
    params = requestDataObject.inventoryGroupId
      ? params.set("inventoryGroupId", requestDataObject.inventoryGroupId)
      : params;
    return this.httpWithoutInterceptor.get<any>(
      this.prodServerUrl + this.URL.productDetails,
      {
        params: params,
      }
    );
  }

  fetchStory(data) {
    let params = new HttpParams();
    params = data.itemMasterGroupId
      ? params.set("itemMasterGroupId", data.itemMasterGroupId)
      : params;
    params = data.businessUnitId
      ? params.set("businessUnitId", data.businessUnitId)
      : params;
    params = data.inventoryGroupId
      ? params.set("inventoryGroupId", data.inventoryGroupId)
      : params;
    params = data ? params.set("storyId", data.storyId) : params;
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getStory + "/" + data.storyId,
      { params: params }
    );
  }

  getHomePageAppointments(settings) {
    let httpParams = new HttpParams();
    if (settings.businessUnitId) {
      httpParams = httpParams.set("businessUnitId", settings.businessUnitId);
    }
    if (settings.status) {
      httpParams = httpParams.set("isStatus", settings.status);
    }
    httpParams = httpParams.set("isHomePage", "true");
    if (!settings.noFromDate) {
      httpParams = httpParams.set(
        "fromDate",
        this.stringDateFormat(settings.fromDate).toString()
      );
    }
    if (settings.isSummery) {
      httpParams = httpParams.set("isSummery", "true");
    }
    if (settings.contactid) {
      httpParams = httpParams.set("contactid", settings.contactid);
    }
    if (settings.isNotHomePage) {
      httpParams = httpParams.set(
        "toDate",
        this.stringDateFormat(settings.toDate).toString()
      );
    }
    if (settings.deleted) {
      httpParams = httpParams.set("deleted", "true");
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.getAppointments, {
      params: httpParams,
    });
  }
  attachmentPreview(data) {
    const file = new Blob([data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank", "true");
  }
  getData(address) {
    return this.http.get(address, { responseType: "arraybuffer" });
  }

  getSegments() {
    return this.http.get<any>(this.prodServerUrl + this.URL.segments);
  }

  getCompanysegmentCategories(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("segmentId", data.segmentId);
    if (data.level) {
      httpParams = httpParams.set("level", data.level);
    }
    if (data.parent) {
      httpParams = httpParams.set("parent", data.parent);
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.companysegmentCategories,
      { params: httpParams }
    );
  }

  getUoms() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("uomKey", "measure");
    httpParams = httpParams.set("isSimple", "true");
    return this.http.get<any>(this.prodServerUrl + this.URL.unitofmeasures, {
      params: httpParams,
    });
  }

  createItemMasterGroup(data, update?) {
    if (!update) {
      return this.http.post<any>(
        this.prodServerUrl + this.URL.itemmastergroupwhiteshop,
        data
      );
    } else {
      return this.http.put<any>(
        this.prodServerUrl + this.URL.itemmastergroupwhiteshop,
        data
      );
    }
  }

  updateAppointmentProductComments(data) {
    if (Cookies.get("trackCId")) {
      data["cookieId"] = Cookies.get("trackCId");
    }
    if (data.username === "") {
      data["username"] = "visitor@shopconnect.com";
    }
    if (sessionStorage.getItem("sessionId")) {
      if (sessionStorage.getItem("sessionId").includes("expire")) {
        let sessionObject = JSON.parse(sessionStorage.getItem("sessionId"));
        data["sessionId"] = sessionObject.sessionId;
      } else {
        data["sessionId"] = sessionStorage.getItem("sessionId");
      }
    }
    if (!data.timeSpent) {
      return this.http.put<any>(
        this.prodServerUrl + this.URL.updateappointmentproducts,
        data
      );
    } else {
      const authToken =
        localStorage.getItem("retailerToken") ||
        localStorage.getItem("nVipaniwhiteshopkey");
      let httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
      };
      if (authToken) {
        httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: authToken,
          }),
        };
      }
      return this.httpWithoutInterceptor.put<any>(
        this.prodServerUrl + this.URL.updateappointmentproducts,
        data,
        httpOptions
      );
    }
  }
  updateAppointmentProducts(
    code: string,
    products,
    key,
    email?: string,
    isSpotB2B?,
    isOrderPreview?
  ) {
    var data = {};
    data["code"] = code;
    data[key] = products;
    if (Cookies.get("trackCId")) {
      data["cookieId"] = Cookies.get("trackCId");
    }
    if (sessionStorage.getItem("sessionId")) {
      if (sessionStorage.getItem("sessionId").includes("expire")) {
        let sessionObject = JSON.parse(sessionStorage.getItem("sessionId"));
        data["sessionId"] = sessionObject.sessionId;
      } else {
        data["sessionId"] = sessionStorage.getItem("sessionId");
      }
    }
    data["isSpotB2B"] = isSpotB2B;
    if (isOrderPreview) {
      data["orderPreview"] = isOrderPreview ? isOrderPreview : undefined;
    }
    if (email) data["email"] = email;
    if (products.classification) {
      if (key === "products") {
        data[key]["classifications"] = [
          { classification: products.classification },
        ];
      } else {
        data["classification"] = products.classification;
      }
    }
    if (products.removeClassification)
      data["removeClassification"] = products.removeClassification;
    if (products.numberOfUnits) data["numberOfUnits"] = products.numberOfUnits;
    if (products.inventoryGroupSet)
      data["inventoryGroupSet"] = products.inventoryGroupSet;
    if (products.inventoriesCount)
      data["inventoriesCount"] = products.inventoriesCount;
    if (products.unitPrice) data["unitPrice"] = products.unitPrice;
    let authToken = localStorage.getItem("retailerToken")
      ? localStorage.getItem("retailerToken")
      : localStorage.getItem("salesPersonToken");

    if (key !== "updateProduct") {
      return this.http.post<any>(API_PATH.apis.updateAppointmentProducts, data);
    }
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    if (authToken) {
      httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      };
    }
    return this.http.post<any>(
      API_PATH.apis.updateAppointmentProducts,
      data,
      httpOptions
    );
  }

  addToWishList(data) {
    if (sessionStorage.getItem("sessionId")) {
      if (sessionStorage.getItem("sessionId").includes("expire")) {
        let sessionObject = JSON.parse(sessionStorage.getItem("sessionId"));
        data["sessionId"] = sessionObject.sessionId;
      } else {
        data["sessionId"] = sessionStorage.getItem("sessionId");
      }
    }
    return this.http.post<any>(
      this.prodServerUrl + this.URL.appointmentProducts,
      data
    );
  }

  removeFromWishList(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.appointmentProducts,
      data
    );
  }

  getWishList() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("type", "Wishlist");
    let data =
      JSON.parse(localStorage.getItem("user")) ||
      JSON.parse(localStorage.getItem("promoUserData"));
    if (data) {
      httpParams = httpParams.set("username", data.username);
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.appointmentProducts,
      { params: httpParams }
    );
  }
  getAllWishlist(
    businessUnitId,
    page = 1,
    limit = 10,
    sortByProduct?,
    searchText?
  ) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("limit", limit.toString());
    httpParams = httpParams.set("page", page.toString());
    httpParams = httpParams.set("businessUnitId", businessUnitId.toString());
    if (searchText && searchText.length) {
      httpParams = httpParams.set("searchText", searchText.toString());
    }
    if (sortByProduct) {
      httpParams = httpParams.set(
        "sortByProductCount",
        sortByProduct.toString()
      );
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.allWishlist, {
      params: httpParams,
    });
  }
  getCompanyWishList(businessUnitId?) {
    let httpParams = new HttpParams();
    if (businessUnitId) {
      httpParams = httpParams.set("businessUnitId", businessUnitId.toString());
    }
    return this.http.get(this.prodServerUrl + this.URL.wishlists, {
      params: httpParams,
      responseType: "arraybuffer",
    });
  }
  getItemMasterGroupById(data, isInventory?, mainId?) {
    let httpParams = new HttpParams();
    if (isInventory) {
      httpParams = httpParams.set("isInventory", isInventory);
      httpParams = httpParams.set("itemMasterGroupId", mainId);
    } else {
      httpParams = httpParams.set("itemMasterGroupId", data);
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getItemMasterGroupById + data,
      { params: httpParams }
    );
  }

  getSalesPerson(bUnitId, fromDate?, toDate?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("businessUnitId", bUnitId);
    if (fromDate && toDate) {
      httpParams = httpParams.set(
        "fromDate",
        this.stringDateFormat(fromDate).toString()
      );
      httpParams = httpParams.set(
        "toDate",
        this.stringDateFormat(toDate).toString()
      );
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.salesperson, {
      params: httpParams,
    });
  }
  getAppointmentSalesPerson(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.appointmentSalesperson,
      data
    );
  }

  createSpotBooking(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.spotBooking, data);
  }

  createSpotBookingB2C(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.spotBookingB2C,
      data
    );
  }

  fetchContactByMailId(mailId, isConsumer?) {
    mailId = mailId && mailId.length > 0 ? mailId.toLowerCase() : "";
    let httpParams = new HttpParams();
    if (isConsumer) {
      httpParams = httpParams
        .set("mailID", mailId.toString())
        .set("findUserAlso", "true")
        .set("isConsumer", "true");
    } else {
      httpParams = httpParams
        .set("mailID", mailId.toString())
        .set("findUserAlso", "true");
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.contactByMailID, {
      params: httpParams,
    });
  }

  getProductsOfCategories(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.getProductsOfCategories,
      data
    );
  }

  createOffer(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.createOffer, data);
  }

  getBusinessUnitOffers(bUnitId) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("businessUnitId", bUnitId);
    httpParams = httpParams.set("limit", "100");
    httpParams = httpParams.set("page", "1");
    return this.http.get<any>(this.prodServerUrl + this.URL.createOffer, {
      params: httpParams,
    });
  }

  getOfferById(businessUnitId) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("businessUnitId", businessUnitId);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getOffersInventory,
      { params: httpParams }
    );
  }

  getExternalOffer(data) {
    let httpParams = new HttpParams();
    if (data.businessUnitId) {
      httpParams = httpParams.set("businessUnitId", data.businessUnitId);
    }
    if (data.code) {
      httpParams = httpParams.set("code", data.code);
    }
    if (data.type) {
      httpParams = httpParams.set("type", data.type);
    }
    if (data.isCategory) {
      httpParams = httpParams.set("isCategory", data.isCategory);
    }
    // httpParams = httpParams.set('type', 'External');
    return this.http.get<any>(this.prodServerUrl + this.URL.externalOffer, {
      params: httpParams,
    });
  }

  postOffer(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.externalOffer,
      data
    );
  }

  greaterThanPresentTime(slot) {
    if (this.greaterThanPresentDate() === "greater") {
      return true;
    } else if (this.greaterThanPresentDate() === "equal") {
      let slotTimeArray = slot.fromTime.split(":");
      let slotHour = parseInt(slotTimeArray[0]);
      slotTimeArray = [
        slotTimeArray[1].slice(0, 2),
        slotTimeArray[1].slice(
          slotTimeArray[1].length - 2,
          slotTimeArray[1].length
        ),
      ];
      let slotMinutes = parseInt(slotTimeArray[0]);
      let date = new Date();
      if (slotHour != 12) {
        slotHour = slotTimeArray[1] === "PM" ? slotHour + 12 : slotHour;
      }
      if (slotHour > date.getHours()) {
        return true;
      } else if (
        slotHour === date.getHours() &&
        slotMinutes > date.getMinutes()
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  greaterThanPresentDate() {
    let date = new Date();
    let slotDate = this.selectedSlotData.selectedDate;
    if (date.getUTCFullYear() < slotDate.getUTCFullYear()) {
      return "greater";
    } else if (date.getUTCFullYear() === slotDate.getUTCFullYear()) {
      if (date.getMonth() < slotDate.getMonth()) {
        return "greater";
      } else if (date.getMonth() > slotDate.getMonth()) {
        return "lesser";
      } else if (date.getMonth() === slotDate.getMonth()) {
        if (date.getDate() < slotDate.getDate()) {
          return "greater";
        } else if (date.getDate() > slotDate.getDate()) {
          return "lesser";
        } else if (date.getDate() === slotDate.getDate()) {
          return "equal";
        }
      }
    } else if (date.getUTCFullYear() > slotDate.getUTCFullYear()) {
      return "lesser";
    }
  }
  getPinCode(pinCode) {
    return Number(pinCode);
  }
  updatePinCode(pinCode) {
    return pinCode && pinCode.length === 5 ? "0" + pinCode : pinCode;
  }
  inventorygroupsets(businessUnitId?, inventoryGroupId?, isOwner?) {
    let currentBusinessUnitId;
    if (sessionStorage.getItem("currentBusinessUnit")) {
      currentBusinessUnitId = JSON.parse(
        sessionStorage.getItem("currentBusinessUnit")
      )._id;
    } else {
      currentBusinessUnitId = sessionStorage.getItem("businessUnit");
    }
    let httpParams = new HttpParams().set(
      "businessUnitId",
      businessUnitId ? businessUnitId : currentBusinessUnitId
    );
    if (inventoryGroupId) {
      httpParams = httpParams.set("inventoryGroupSetGroupId", inventoryGroupId);
    }
    if (isOwner) {
      httpParams = httpParams.set("isOwner", isOwner);
    }
    return this.http.get<any>(this.prodServerUrl + "/inventorygroupsets", {
      params: httpParams,
    });
  }
  getGroupsData(businessUnitId, inventoryGroupSetGroups) {
    console.log(businessUnitId);
    let httpParams = new HttpParams().set("businessUnitId", businessUnitId);
    return this.http.post<any>(
      this.prodServerUrl + this.URL.getGroupsData,
      { inventoryGroupSetGroups: inventoryGroupSetGroups },
      {
        params: httpParams,
      }
    );
  }
  getCollectionData(id, collectionBoard?, similar?, searchText?) {
    let httpParams = new HttpParams()
      .set("isInventoryGroup", "true")
      .set("inventoryGroupCollectionId", id)
      .set("isRoomPlaner", "true");
    if (collectionBoard) {
      if (similar) {
        httpParams = new HttpParams()
          .set("collectionId", id)
          .set("similar", "true");
        if (similar === "inventory") {
          httpParams = httpParams.set("inventory", "true");
        }
      } else {
        httpParams = new HttpParams().set("collectionId", id);
      }
      if (searchText) {
        httpParams = httpParams.set("searchText", searchText);
      }
      return this.http.get<any>(
        this.prodServerUrl + "/collectionboardinventorygroups",
        {
          params: httpParams,
        }
      );
    } else {
      return this.http.get<any>(this.prodServerUrl + "/getInventoryAggregate", {
        params: httpParams,
      });
    }
  }
  getGradeDefinitions(
    businessUnit,
    isCount?,
    isArchive?,
    is360Degree?,
    hasProductVideo?,
    orderLink?,
    isRoomPlan?,
    subCategory?,
    boardId?
  ) {
    let httpParams = new HttpParams();
    if (!orderLink) {
      httpParams = httpParams.set("busUnitId", businessUnit.toString());
    }
    if (isCount) {
      httpParams = httpParams.set("count", "true");
    }
    if (isArchive !== undefined) {
      httpParams = httpParams.set("archive", isArchive);
    }
    if (is360Degree) {
      httpParams = httpParams.set("is360Degree", "true");
    }
    if (hasProductVideo) {
      httpParams = httpParams.set("hasProductVideo", "true");
    }
    if (orderLink) {
      httpParams = httpParams.set("orderLink", orderLink);
    }
    if (isRoomPlan) {
      httpParams = httpParams.set("isRoomPlan", "true");
    }
    if (subCategory) {
      httpParams = httpParams.set("subCategory", subCategory);
    }
    if (boardId) {
      httpParams = httpParams.set("boardId", boardId);
    }
    return this.http.get<any>(this.prodServerUrl + "/getgradedefinitions", {
      params: httpParams,
    });
  }
  getBoardDetails() {
    return this.http.get<any>(this.prodServerUrl + this.URL.boardDetails);
  }

  createBoard(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.createBoard, data);
  }
  inventoryGroupGroupActions(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.inventoryGroupsGroupActions,
      data
    );
  }
  inventoryGroupSetOrder(data) {
    // console.log(data.inventoryGroups[0]._id)
    return this.http.post<any>(
      this.prodServerUrl + this.URL.inventoryGroupSetOrder,
      data
    );
  }
  createOfferLink(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.offerLink, data);
  }

  updatePromoLink(data) {
    return this.http.put<any>(this.prodServerUrl + this.URL.offerLink, data);
  }

  getOfferLinkCodeData(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.offerLinkCode,
      data
    );
  }

  sendResendOrderLink(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.sendResendLink,
      data
    );
  }

  getCurrentUser() {
    return this.http.post<any>(this.prodServerUrl + this.URL.currentUser, {});
  }
  getRoomPlanerList(
    businessUnit,
    page,
    limit,
    isSalesPerson?,
    searchText?,
    sortType?,
    sortItem?
  ) {
    let params = new HttpParams();
    params = params.set("businessUnitId", businessUnit);
    if (page) {
      params = params.set("page", page).set("limit", limit);
    }
    if (isSalesPerson) {
      params = params.set("isSalesPerson", "true");
    }
    if (searchText) {
      params = params.set("searchText", searchText);
    }
    if (sortType) {
      params = params.set("sortType", sortType);
    }
    if (sortItem) {
      params = params.set("sortItem", sortItem);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.getRequest, {
      params: params,
    });
  }
  getOrderLinkList(
    businessUnit,
    event?,
    limit?,
    type?,
    isSalesPerson?,
    searchText?,
    fromDate?,
    toDate?,
    isDownloadLink?,
    showActive?
  ) {
    let params = new HttpParams();
    params = params.set("businessUnitId", businessUnit);
    params = params.set("ignoreFromDate", "true");
    if (event) {
      params = params.set("page", event).set("limit", limit);
    }
    if (type) {
      params = params.set("type", "true");
    }
    if (isSalesPerson) {
      params = params.set("isSalesPerson", "true");
    }
    if (searchText) {
      params = params.set("searchText", searchText);
    }
    if (isDownloadLink) {
      params = params.set("isDownloadLink", isDownloadLink);
    }
    if (showActive) {
      params = params.set("showActive", showActive);
    }
    if (fromDate && toDate) {
      params = params.set("fromDate", this.stringDateFormat(fromDate));
      params = params.set("toDate", this.stringDateFormat(toDate));
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.offerLink, {
      params: params,
    });
  }
  updateOrderLink(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.offerLinkCode,
      data
    );
  }
  deleteOrderLink(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.deleteOrderLink,
      data
    );
  }
  changeOrderLinkStatus(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.changeOrderLinkStatus,
      data
    );
  }
  itemMasterGroupById(id) {
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getItemMasters + "/" + id
    );
  }
  filterImages(images) {
    return images.filter((each) => each && !each.type);
  }
  getOrderLinkData(code, email?) {
    let params = new HttpParams().set("linkCode", code.toString());
    if (email) {
      params = params.set("email", email);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.orderLinkData, {
      params: params,
    });
  }
  getCustomerOrderLinkData(linkCode, email?, mobile?) {
    let data = { linkCode };
    if (email) {
      data["email"] = email;
    }
    if (mobile) {
      data["mobile"] = mobile.toString();
    }
    return this.http.post<any>(
      this.prodServerUrl + this.URL.orderLinkData,
      data
    );
  }
  getBusinessUnitCollection(businessUnit) {
    const httpParams = new HttpParams().set("busUnitId", businessUnit);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.businessUnitCollections,
      { params: httpParams }
    );
  }
  getCartTypes(each) {
    let cartData = "";
    if (each.classifications && each.classifications.length) {
      each.classifications.forEach((each) => {
        cartData +=
          cartData && cartData.length
            ? "," + (each.classification ? each.classification : each.name)
            : each.classification
            ? each.classification
            : each.name;
      });
    }
    return cartData;
  }
  isCartTypes(data) {
    return (
      data &&
      data.settings &&
      data.settings.appointment &&
      data.settings.appointment.isInventoryGroupNumberOfUnits &&
      data.settings.appointment.classifications &&
      data.settings.appointment.classifications.length
    );
  }
  mapDealerPrice(price, multipleWSP, sequence) {
    if (sequence !== undefined && multipleWSP && multipleWSP.length) {
      const index = multipleWSP.findIndex((each) => each.sequence === sequence);
      if (index > -1) {
        price["dealerPrice"] = multipleWSP[index].value
          ? multipleWSP[index]
          : multipleWSP[0];
      }
    }
  }
  getAppointmentBoards(code, businessUnit) {
    const httpParams = new HttpParams()
      .set("businessUnitId", businessUnit)
      .set("code", code);
    return this.http.get<any>(this.prodServerUrl + this.URL.appointmentboards, {
      params: httpParams,
    });
  }
  getAppointmentBoardsCustomer(code, businessUnit, email) {
    const httpParams = new HttpParams()
      .set("businessUnitId", businessUnit)
      .set("code", code);
    return this.http.post<any>(
      this.prodServerUrl + this.URL.appointmentboards,
      { email: email },
      {
        params: httpParams,
      }
    );
  }
  getInventoriesByInventoryGroup(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.getInventories,
      data
    );
  }

  getDivisions(businessUnit?) {
    const httpParams = new HttpParams();
    return this.http.get<any>(this.prodServerUrl + this.URL.division, {
      params: httpParams,
    });
  }

  createDivision(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.division, data);
  }

  updateDivision(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.division + "/" + data._id,
      data
    );
  }

  getAppointmentGroups(userId?, company?, businessUnit?) {
    let httpParams = new HttpParams();
    if (userId) {
      httpParams = httpParams.set("salesPerson", userId);
    }
    if (company) {
      httpParams = httpParams.set("company", company);
    }
    if (businessUnit) {
      httpParams = httpParams.set("businessUnitId", businessUnit);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.appointmentgroup, {
      params: httpParams,
    });
  }
  getCompanyConfigBykey(key) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("key", key).set("isConfig", "true");
    return this.http.get(this.prodServerUrl + "/c2CKeyConfig", {
      params: httpParams,
    });
  }
  getMinFromDate(date) {
    date.setFullYear(date.getFullYear() - 1);
  }
  getTitanExcelOffer(
    inventoryGroups,
    sizes,
    isConst,
    code?,
    reportType?,
    businessUnit?
  ) {
    return this.http.post(
      this.prodServerUrl + this.URL.getInventorySnapshop,
      {
        inventoryGroups: inventoryGroups,
        isConst: isConst,
        sizes: sizes,
        businessUnit: businessUnit
          ? businessUnit
          : this.currentBusinessUnit._id,
        code: code,
        reportType: reportType,
      },
      { responseType: "arraybuffer", reportProgress: true, observe: "events" }
    );
  }
  getMacysAffinityReport(
    code,
    type,
    orderId?,
    email?,
    businessUnit?,
    country?
  ) {
    return this.http.get(
      this.prodServerUrl +
        this.URL.getAppointmentReport +
        "?code=" +
        code +
        (orderId ? "&orderId=" + orderId : "") +
        "&type=" +
        type +
        (email ? "&email=" + email : "") +
        (this.currentBusinessUnit
          ? "&businessUnit=" + this.currentBusinessUnit._id
          : "") +
        (country ? "&country=" + country : ""),
      { responseType: "arraybuffer" }
    );
  }

  getOrderInvoice(orderId, companyLogo, country, withoutInterceptor?) {
    let httpParams = new HttpParams()
      .set("type", "Invoice")
      .set("sendPosEmail", "false")
      .set("scOrder", "true");

    if (companyLogo) {
      httpParams = httpParams.set("companyLogo", companyLogo);
    } else if (isSRSMFlag.flag) {
      httpParams = httpParams.set("srsmIcon", "true");
    } else if (isJDXHomePage.flag && !isJDXHomePage.isHighLine) {
      httpParams = httpParams.set("jdxLogo", "true");
    } else if (isJDXHomePage.isHighLine) {
      httpParams = httpParams.set("highlineLogo", "true");
    } else if (isHappyBabyFlag.flag) {
      httpParams = httpParams.set("happybabyIcon", "true");
    } else {
      httpParams = httpParams.set("whiteShopIcon", "true");
    }
    if (country) {
      httpParams = httpParams.set("country", "true");
    }
    const authToken =
      localStorage.getItem("retailerToken") ||
      localStorage.getItem("nVipaniwhiteshopkey");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    if (authToken) {
      httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      };
    }

    return (withoutInterceptor ? this.httpWithoutInterceptor : this.http).get(
      this.prodServerUrl + this.URL.orderInvoice + "/" + orderId,
      {
        params: httpParams,
        responseType: "arraybuffer",
        headers: withoutInterceptor ? httpOptions.headers : undefined,
      }
    );
  }

  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowHeight = dimensions.windowHeight;
    this.windowWidth = dimensions.windowWidth;
    const vh = (window.innerHeight - 1) * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
  isMobileDevices() {
    return this.windowWidth <= 6;
  }
  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 12;
  }
  getProductLineReport(
    inventoryGroups,
    type,
    isMyOrders?,
    showProgress?,
    businessUnit?,
    isSelections?,
    fromDate?,
    toDate?,
    salespersons?,
    country?,
    quoteStatus?
  ) {
    if (!showProgress) {
      return this.http.post(
        this.prodServerUrl + this.URL.getAppointmentReport + "?type=" + type,
        {
          inventoryGroups: inventoryGroups,
          businessUnit: businessUnit
            ? businessUnit
            : this.currentBusinessUnit._id,
          isSelections: isSelections,
          fromDate: fromDate,
          toDate: toDate,
          salespersons: salespersons,
          country: country,
        },
        {
          responseType: "arraybuffer",
          reportProgress: isMyOrders ? undefined : true,
          observe: isMyOrders ? undefined : "events",
        }
      );
    } else {
      let authToken = localStorage.getItem("retailerToken")
        ? localStorage.getItem("retailerToken")
        : localStorage.getItem("salesPersonToken");
      let httpHeaders = new HttpHeaders({
        Authorization: authToken,
      });
      return this.httpWithoutInterceptor.post(
        this.prodServerUrl + this.URL.getAppointmentReport + "?type=" + type,
        {
          inventoryGroups: inventoryGroups,
          businessUnit: businessUnit
            ? businessUnit
            : this.currentBusinessUnit._id,
          isSelections: isSelections,
          fromDate: fromDate ? this.stringDateFormat(fromDate) : null,
          toDate: toDate ? this.stringDateFormat(toDate) : null,
          quoteStatus: quoteStatus,
        },
        {
          responseType: "arraybuffer",
          reportProgress: isMyOrders ? undefined : true,
          observe: isMyOrders ? undefined : "events",
          headers:
            localStorage.getItem("retailerToken") ||
            localStorage.getItem("salesPersonToken")
              ? httpHeaders
              : undefined,
        }
      );
    }
  }
  createExcelOrder(inventoryGroups, type, isCasepacks) {
    return this.http.post(
      this.prodServerUrl + this.URL.createExcelOrder,
      {
        inventoryGroups: inventoryGroups,
        type: type,
        isCasePacks: isCasepacks,
        businessUnit: this.currentBusinessUnit._id,
      },
      { responseType: "arraybuffer", reportProgress: true, observe: "events" }
    );
  }
  getGradeValue(definition, attribute, brackets = false) {
    const index = definition.findIndex(
      (eachDefinition) => eachDefinition.attributeKey === attribute
    );
    return index === -1
      ? " "
      : brackets
      ? "(" + definition[index].attributeValue + ")"
      : definition[index].attributeValue;
  }
  getInventorySnapshop() {
    return this.http.get(
      this.prodServerUrl +
        this.URL.getInventorySnapshop +
        ("?businessUnit=" + this.currentBusinessUnit._id),
      { responseType: "arraybuffer", reportProgress: true, observe: "events" }
    );
  }
  getAvailableDate(availableDate) {
    return (
      ["on hand", "immed"].findIndex((each) => each === availableDate) > -1
    );
  }
  getDashboardReport(
    code,
    isPromotionLink,
    isVisits?,
    inventoryGroupSet?,
    isProductViews?,
    email?,
    userProductViews?,
    userCartProducts?,
    date?,
    filterData?,
    withoutInterceptor?,
    ipAddress?
  ) {
    let timeZone = this.currentBusinessUnit.settings.appointment?.timeZone?.split(
      " "
    );
    let httpParams = new HttpParams()
      .set("code", code)
      .set("isPromotionLink", isPromotionLink)
      .set(
        "timeZone",
        timeZone && timeZone[timeZone.length - 1]
          ? timeZone[timeZone.length - 1]
          : moment.tz.guess()
      );
    if (isVisits) {
      httpParams = httpParams.set("isVisits", "true");
    }
    if (inventoryGroupSet) {
      httpParams = httpParams.set("inventoryGroupSet", inventoryGroupSet);
    }
    if (isProductViews) {
      httpParams = httpParams.set("isProductViews", "true");
    }
    if (email) {
      httpParams = httpParams.set("email", email);
    }
    if (userProductViews) {
      httpParams = httpParams.set("userProductViews", "true");
    }
    if (userCartProducts) {
      httpParams = httpParams.set("userCartProducts", "true");
    }
    if (date) {
      httpParams = httpParams.set("date", this.stringDateFormat(date));
    }
    if (ipAddress) {
      httpParams = httpParams.set("ipAddress", ipAddress);
    }

    const authToken =
      localStorage.getItem("retailerToken") ||
      localStorage.getItem("nVipaniwhiteshopkey");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    if (authToken) {
      httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      };
    }

    if (filterData) {
      return (withoutInterceptor
        ? this.httpWithoutInterceptor
        : this.http
      ).post<any>(
        this.prodServerUrl + this.URL.dashboardReport,
        { filterData },
        {
          params: httpParams,
          headers: withoutInterceptor ? httpOptions.headers : undefined,
        }
      );
    } else {
      return (withoutInterceptor
        ? this.httpWithoutInterceptor
        : this.http
      ).get<any>(this.prodServerUrl + this.URL.dashboardReport, {
        params: httpParams,
        headers: withoutInterceptor ? httpOptions.headers : undefined,
      });
    }
  }

  getDashboardReportData(fromDate, toDate, code?) {
    let httpParams = new HttpParams()
      .set("isFromDate", fromDate)
      .set("isToDate", toDate)
      .set("timeZone", moment.tz.guess());
    if (code) {
      httpParams = httpParams.set("code", code);
    }
    return this.http.get(this.prodServerUrl + "/dashboardData", {
      params: httpParams,
      responseType: "arraybuffer",
    });
  }
  getVideoCallReportData(fromDate, toDate, report) {
    let httpParams = new HttpParams()
      .set("type", report)
      .set("timeZone", moment.tz.guess());
    if (fromDate) {
      httpParams = httpParams.set("fromDate", fromDate);
    }
    if (toDate) {
      httpParams = httpParams.set("toDate", toDate);
    }
    return this.http.get(this.prodServerUrl + "/getData", {
      params: httpParams,
      responseType: "arraybuffer",
    });
  }

  checkLinkData(data) {
    this.orderLinkCode = data.linkCode;
    this.promoLinkUsername = data.username;
    return this.http.post<any>(
      this.prodServerUrl + this.URL.checkLinkData,
      data
    );
  }
  updateAppointmentUser(code) {
    let httpParams = new HttpParams().set("appointmentCode", code);
    if (localStorage.getItem("promoUserData") || localStorage.getItem("user")) {
      let user =
        JSON.parse(localStorage.getItem("user")) ||
        JSON.parse(localStorage.getItem("promoUserData"));
      httpParams = httpParams.set("username", user.username);
      httpParams = httpParams.set(
        "displayName",
        user.name ? user.name : user.displayName
      );
      if (user.email) {
        httpParams = httpParams.set("email", user.email);
      }
      if (user.mobile) {
        httpParams = httpParams.set("mobile", user.mobile);
      }
    }
    return this.http.get(this.prodServerUrl + this.URL.updateAppointmentUser, {
      params: httpParams,
    });
  }
  getLandingPageData(code) {
    const httpParams = new HttpParams().set("code", code);
    return this.http.get(this.prodServerUrl + this.URL.getLandingPageData, {
      params: httpParams,
    });
  }
  getUserCartData(data) {
    const httpParams = new HttpParams()
      .set("user", data.user)
      .set("businessUnit", data.businessUnit);
    return this.http.get<any>(this.prodServerUrl + this.URL.getUserCartData, {
      params: httpParams,
    });
  }
  downloadFile(data, name, isCsv?) {
    const reportMimeType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    console.log(data);
    const file = new Blob([data], { type: reportMimeType });
    const fileURL = URL.createObjectURL(file);
    // window.open(fileURL);
    const anchor = document.createElement("a");
    anchor.download = name + (isCsv ? ".csv" : ".xlsx");
    anchor.href = fileURL;
    anchor.click();
  }

  getFilteredBoardData(element) {
    return element && element.boardData
      ? element.boardData.filter(
          (eachData, index) =>
            element.boardData.findIndex(
              (each1) => each1.type === eachData.type
            ) === index &&
            this.unusedTypes.findIndex((each) => eachData.type === each) === -1
        )
      : [];
  }

  getIpAddress() {
    return this.httpWithoutInterceptor.get<any>(
      this.prodServerUrl + this.URL.getMyIp
    );
  }

  createOrGetShortUrl(data) {
    const authToken =
      localStorage.getItem("retailerToken") ||
      localStorage.getItem("nVipaniwhiteshopkey");
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    if (authToken) {
      httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      };
    }
    return this.httpWithoutInterceptor.post<any>(
      this.prodServerUrl + this.URL.shortLink,
      data,
      httpOptions
    );
  }

  getShortLinkById(id) {
    return this.http.get<any>(
      this.prodServerUrl + this.URL.shortLink + "/" + id
    );
  }

  getSharedWithData(data) {
    const httpParams = new HttpParams().set("orderLinkId", data);
    return this.http.get(this.prodServerUrl + this.URL.shareOrderLink, {
      params: httpParams,
    });
  }

  setSharedWithData(data, isUpdate) {
    if (isUpdate) {
      return this.http.put(this.prodServerUrl + this.URL.shareOrderLink, data);
    } else {
      return this.http.post(this.prodServerUrl + this.URL.shareOrderLink, data);
    }
  }

  updateSharedWithData(data) {
    return this.http.put(this.prodServerUrl + this.URL.shareOrderLink, data);
  }

  compareTime(fromTiming, currentDateValue, duration?) {
    if (fromTiming) {
      var moment = require("moment-timezone");
      this.presentTimeZone = moment.tz.guess();
      let presentTimeValue = new Date();
      if (duration) {
        presentTimeValue.setMinutes(presentTimeValue.getMinutes() + duration);
      }
      let presentTime = new Date(
        new Date(presentTimeValue).toLocaleString("en-US", {
          timeZone: this.presentTimeZone,
        })
      );
      let presentTimeDate = presentTime.getDate();
      let slotDate = currentDateValue.getDate();
      let presentTimeMonth = presentTime.getMonth();
      let slotMonth = currentDateValue.getMonth();
      let splitHourMin = fromTiming.split(":");
      let fromTimeHour = parseInt(splitHourMin[0]);
      let fromTimeMinutes = parseInt(splitHourMin[1]);
      if (fromTiming.slice(-2) === "PM" && !fromTiming.includes("12")) {
        fromTimeHour += 12;
      }
      if (
        (presentTimeDate > slotDate && presentTimeMonth >= slotMonth) ||
        presentTimeMonth > slotMonth
      ) {
        return false;
      } else if (
        (presentTimeDate < slotDate && presentTimeMonth === slotMonth) ||
        presentTimeMonth < slotMonth
      ) {
        return true;
      } else if (presentTime.getHours() < fromTimeHour) {
        return true;
      } else if (presentTime.getHours() > fromTimeHour) {
        return false;
      } else {
        return presentTime.getMinutes() < fromTimeMinutes;
      }
    } else {
      return false;
    }
  }

  createInstantProduct(data) {
    return this.http.post<any>(
      this.prodServerUrl + this.URL.instantProducts,
      data
    );
  }

  getInstantProducts(data) {
    let httpParams = new HttpParams();
    if (data.businessUnitId) {
      httpParams = httpParams.set("businessUnitId", data.businessUnitId);
    }
    if (data.appointmentCode) {
      httpParams = httpParams.set("appointmentCode", data.appointmentCode);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.instantProducts, {
      params: httpParams,
    });
  }

  updateInstantProduct(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.instantProducts,
      data
    );
  }

  compareToTime(toTiming, currentDateValue) {
    if (toTiming) {
      var moment = require("moment-timezone");
      let slotDate = currentDateValue.getDate();
      let slotMonth = currentDateValue.getMonth();
      this.presentTimeZone = moment.tz.guess();
      let presentTimeValue = new Date();
      let currentTime = new Date(
        presentTimeValue.toLocaleString("en-US", {
          timeZone: this.presentTimeZone,
        })
      );
      let currentTimeDate = currentTime.getDate();
      let currentTimeMonth = currentTime.getMonth();
      let splitToTime = toTiming?.split(":");
      let toTimeHour = parseInt(splitToTime[0]);
      let toTimeMinutes = parseInt(splitToTime[1]);
      if (toTiming?.slice(-2) === "PM" && !toTiming?.includes("12")) {
        toTimeHour += 12;
      }
      if (
        (currentTimeDate > slotDate && currentTimeMonth >= slotMonth) ||
        currentTimeMonth > slotMonth ||
        (currentTimeDate === slotDate &&
          currentTimeMonth === slotMonth &&
          (currentTime.getHours() > toTimeHour ||
            (currentTime.getHours() === toTimeHour &&
              currentTime.getMinutes() > toTimeMinutes)))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  createCodShipment(data) {
    return this.http.post(API_PATH.apis.codShipment, data);
  }

  getReasons(data, company?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("type", data);
    if (company) {
      httpParams = httpParams.set("company", company);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.reasons, {
      params: httpParams,
    });
  }

  addReason(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.reasons, data);
  }

  updateReason(data) {
    return this.http.put<any>(this.prodServerUrl + this.URL.reasons, data);
  }

  getNotifications(limit?, skipCount?, isNotViewed?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("isShopconnect", "true");
    if (skipCount || limit) {
      httpParams = httpParams.set("limit", limit.toString());
      httpParams = httpParams.set("skipCount", skipCount);
    }
    if (isNotViewed) {
      httpParams = httpParams.set("isNotViewed", isNotViewed);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.notifications, {
      params: httpParams,
    });
  }

  clearNotifications(data, isShopconnect, limit?, skipCount?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("notificationId", data);
    httpParams = httpParams.set("isShopconnect", isShopconnect);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.clearNotifications,
      { params: httpParams }
    );
  }
  redirectPoweredBy() {
    window.open("https://shopconnect.live");
  }

  updateNotification(data) {
    return this.http.put<any>(
      this.prodServerUrl + this.URL.updateNotifications + data._id,
      { viewed: data.viewed }
    );
  }

  getInventoriesByInventoryGroupId(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("inventoryGroupId", data);
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getInventoriesByInventoryGroup,
      { params: httpParams }
    );
  }
  getOrderLinksSummary(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("type", "productsviewed");
    httpParams = httpParams.set("fromDate", data.fromDate);
    httpParams = httpParams.set("toDate", data.toDate);
    return this.http.get(
      this.prodServerUrl +
        this.URL.getOrderLinksSummary +
        "?type=productsviewed&fromDate=" +
        data.fromDate +
        "&toDate=" +
        data.toDate +
        "businessUnitId=" +
        this.currentBusinessUnit._id,
      {
        responseType: "arraybuffer",
      }
    );
  }
  getDiscountPercentage(selectedSizeObject, materialPrice?) {
    let configuratorPrice = 0;
    selectedSizeObject.virtualProductConfigurations?.forEach((conf) => {
      configuratorPrice += conf.price;
    });
    const mrp =
      (selectedSizeObject.price &&
      selectedSizeObject.price.MRP &&
      selectedSizeObject.price.MRP.value
        ? selectedSizeObject.price.MRP.value
        : selectedSizeObject.price
        ? selectedSizeObject.price
        : selectedSizeObject.mrp
        ? selectedSizeObject.mrp
        : 0) + (materialPrice || configuratorPrice || 0);
    const dealerPrice =
      (selectedSizeObject.price &&
      selectedSizeObject.price.dealerPrice &&
      selectedSizeObject.price.dealerPrice.value
        ? selectedSizeObject.price.dealerPrice.value
        : selectedSizeObject.dealerPrice
        ? selectedSizeObject.dealerPrice
        : 0) + (materialPrice || configuratorPrice || 0);
    return this.isRidhiMehra
      ? Math.round(
          ((mrp -
            (selectedSizeObject.price &&
            selectedSizeObject.price.dealerPrice &&
            selectedSizeObject.price.dealerPrice.value
              ? selectedSizeObject.price.dealerPrice.value
              : selectedSizeObject.dealerPrice
              ? selectedSizeObject.dealerPrice
              : 0)) /
            mrp) *
            100
        )
      : (((mrp - dealerPrice) / mrp) * 100).toFixed(2);
  }
  checkRM() {
    let flag = getQueryParam("checkingDomain", this.router);
    if (flag && flag.length && !this.isRidhiMehra) {
      this.isRidhiMehra = flag === "RM";
    }
  }

  getUrlSlug(code, name) {
    let codeArray = code.split("-");
    let finalCode;
    finalCode = Date.now();
    let nameArray = name.split(" ");
    nameArray.forEach((element) => {
      finalCode = finalCode + "-" + element;
    });
    return finalCode;
  }

  storeAccessToken(data) {
    return this.http.post(this.prodServerUrl + this.URL.instagramToken, data);
  }

  createInstagramMedia(data) {
    this.toastrService.info("Your post is being published on instagram", null, {
      timeOut: 2000,
    });
    this.http
      .post(this.prodServerUrl + this.URL.createInstagramMedia, data)
      .subscribe(
        (res: any) => {
          if (res.publishRes.id) {
            this.toastrService.info("Image published on instagram", null, {
              timeOut: 2000,
            });
          }
          if (res.limitWarning) {
            this.toastrService.info(
              "You have reached your daily posts limit",
              null,
              {
                timeOut: 2000,
              }
            );
          }
        },
        (err) => {
          if (err.error.code === 190) {
            this.toastrService.error(
              "Access token has expired. Please login again",
              null,
              {
                timeOut: 2000,
              }
            );
          } else {
            this.toastrService.error(err.error.message, null, {
              timeOut: 2000,
            });
          }
        }
      );
  }
  findIsOwner() {
    const config = JSON.parse(localStorage.getItem("companyConfig"));
    const currentUser = JSON.parse(localStorage.getItem("user"));
    return (
      currentUser &&
      config &&
      config.owner &&
      config.owner.user &&
      config.owner.user === currentUser._id
    );
  }

  getFacebookImg(data) {
    return this.httpWithoutInterceptor.post(
      this.prodServerUrl + this.URL.getFacebookImg,
      data
    );
  }

  checkYoutubeLinkValidity(link) {
    return this.httpWithoutInterceptor.get<any>(
      "https://www.youtube.com/oembed?format=json&url=" + link
    );
  }
  exportData(type) {
    return this.http.get(
      this.prodServerUrl +
        this.URL.exportData +
        "?type=" +
        type +
        "&businessUnit=" +
        this.currentBusinessUnit._id,
      { responseType: "arraybuffer" }
    );
  }
  formatAddress(addressObj) {
    if (addressObj && addressObj.addressLine) {
      let addressList = addressObj.addressLine.match(
        /(?=\S)[^,]+?(?=\s*(,|$))/g
      );
      const subAddressList = [
        addressObj.city,
        addressObj.state,
        addressObj.country,
      ];
      const checkPinCode = addressObj.pinCode;
      if (addressList.length > 1) {
        addressList = addressList.filter((subAdd) => {
          return (
            !subAddressList.includes(subAdd) &&
            !(checkPinCode && subAdd.includes(checkPinCode))
          );
        });
        addressObj.addressLine =
          addressList.length > 1
            ? addressList.join(", ")
            : addressList.length
            ? addressList[0]
            : "";
      }
    }
    let formattedAddress = [];
    const requiredFields = [
      "addressLine",
      "city",
      "state",
      "country",
      "pinCode",
    ];
    requiredFields.forEach((item) => {
      if (addressObj[item] && addressObj[item].length > 0) {
        formattedAddress.push(addressObj[item]);
      }
    });
    return formattedAddress.length ? formattedAddress.join(", ") : "";
  }

  checkElementInWishList = (item: {
    id: string | undefined;
    sortedVirtualProductConfigurations: Array<string>;
  }) => {
    return this.wishList.some(
      (wishListItem) =>
        wishListItem.id === item.id &&
        JSON.stringify(item.sortedVirtualProductConfigurations) ===
          JSON.stringify(wishListItem.virtualProductConfigurations)
    );
  };
  addItemToWishList = (item) => {
    if (!this.checkElementInWishList(item))
      this.wishList.push({
        id: item.id,
        virtualProductConfigurations: item.sortedVirtualProductConfigurations,
      });
  };
  deleteFromWishList = (item: {
    id: string;
    sortedVirtualProductConfigurations: Array<string>;
  }) => {
    const index = this.wishList.findIndex(
      (wishListItem) =>
        wishListItem.id === item.id &&
        JSON.stringify(item.sortedVirtualProductConfigurations) ===
          JSON.stringify(wishListItem.virtualProductConfigurations)
    );
    if (index >= 0) this.wishList.splice(index, 1);
  };

  enableCookies() {
    let cookieDialogConfig = new MatDialogConfig();
    cookieDialogConfig.maxHeight = "100vh";
    cookieDialogConfig.maxWidth = "100vw";
    cookieDialogConfig.width = "100vw";
    cookieDialogConfig.height = "95vh";
    cookieDialogConfig.position = { bottom: "0" };
    cookieDialogConfig.disableClose = false;
    cookieDialogConfig.data = { isLogin: true };
    cookieDialogConfig.hasBackdrop = false;
    let loginDialog = this.dialog.open(
      EnableCookiesComponent,
      cookieDialogConfig
    );
  }

  setVirtualStoreTimeOut(seconds) {
    this.userDetailsFormCount += 1;
    setTimeout(() => {
      if (!localStorage.getItem("user") && !this.userDetailsFormSubmitted)
        this.showUserDetailsForm = true;
      this.threedUserForm.next(true);
      this.threedUserForm.next(false);
    }, seconds * 1000);
  }
  fetchComponentData(productID) {
    let params = new HttpParams();
    if (productID) {
      params = params.set("inventoryGroupId", productID);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.getComponents, {
      params: params,
    });
  }

  windowUrlLoad(type) {
    var message;
    var source = "?source=widget";
    if (type === "appointments") {
      message = JSON.stringify({
        url: location.origin + "/appointments" + source,
      });
    } else if (type === "myorders") {
      message = JSON.stringify({
        url: location.origin + "/myorders" + source,
      });
    } else if (type === "myaddresses") {
      message = JSON.stringify({
        url: location.origin + "/myaddresses" + source,
      });
    } else if (type === "wishlist") {
      message = JSON.stringify({
        url: location.origin + "/mywishlist" + source,
      });
    }
    window.parent.postMessage(message, "*");
  }
  removePaymentModesAndTerms(data) {
    if (data?.settings?.paymentModes) {
      data.settings.paymentModes = [];
    }
    if (data?.settings?.paymentTerms) {
      data.settings.paymentTerms = [];
    }
  }

  isCurrentTimeActive(nowTime, fromTime, toTime) {
    let slotTimeArrayFromTime = fromTime.split(":");
    let slotHourFromTime = parseInt(slotTimeArrayFromTime[0]);
    slotTimeArrayFromTime = [
      slotTimeArrayFromTime[1].slice(0, 2),
      slotTimeArrayFromTime[1].slice(
        slotTimeArrayFromTime[1].length - 2,
        slotTimeArrayFromTime[1].length
      ),
    ];
    let slotMinutesFromTime = parseInt(slotTimeArrayFromTime[0]);
    if (slotHourFromTime === 12) {
      slotHourFromTime =
        slotTimeArrayFromTime[1] === "AM" ? 0 : slotHourFromTime;
    }
    if (slotHourFromTime != 12) {
      slotHourFromTime =
        slotTimeArrayFromTime[1] === "PM"
          ? slotHourFromTime + 12
          : slotHourFromTime;
    }

    let slotTimeArrayToTime = toTime.split(":");
    let slotHourToTime = parseInt(slotTimeArrayToTime[0]);
    slotTimeArrayToTime = [
      slotTimeArrayToTime[1].slice(0, 2),
      slotTimeArrayToTime[1].slice(
        slotTimeArrayToTime[1].length - 2,
        slotTimeArrayToTime[1].length
      ),
    ];
    let slotMinutesToTime = parseInt(slotTimeArrayToTime[0]);
    if (slotHourToTime === 12) {
      slotHourToTime = slotTimeArrayToTime[1] === "AM" ? 0 : slotHourToTime;
    }
    if (slotHourToTime != 12) {
      slotHourToTime =
        slotTimeArrayToTime[1] === "PM" ? slotHourToTime + 12 : slotHourToTime;
    }

    let slotTimeArray = nowTime.split(":");
    let slotHour = parseInt(slotTimeArray[0]);
    slotTimeArray = [
      slotTimeArray[1].slice(0, 2),
      slotTimeArray[1].slice(
        slotTimeArray[1].length - 2,
        slotTimeArray[1].length
      ),
    ];
    let slotMinutes = parseInt(slotTimeArray[0]);
    if (slotHour === 12) {
      slotHour = slotTimeArray[1] === "AM" ? 0 : slotHour;
    }
    if (slotHour != 12) {
      slotHour = slotTimeArray[1] === "PM" ? slotHour + 12 : slotHour;
    }
    let inBetweenTime =
      60 * slotHour + slotMinutes <= 60 * slotHourToTime + slotMinutesToTime &&
      60 * slotHour + slotMinutes >=
        60 * slotHourFromTime + slotMinutesFromTime;
    let onTime =
      60 * slotHour + slotMinutes === 60 * slotHourToTime + slotMinutesToTime ||
      60 * slotHour + slotMinutes ===
        60 * slotHourFromTime + slotMinutesFromTime;
    if (
      onTime ||
      (60 * slotHourToTime + slotMinutesToTime >
      60 * slotHourFromTime + slotMinutesFromTime
        ? inBetweenTime
        : !inBetweenTime)
    ) {
      return true;
    }
    return false;
  }

  getDivisionsForBooking(nowTime, groupsList) {
    let divisions = [];
    const deniedAppointments =
      JSON.parse(localStorage.getItem("deniedAppointments")) ?? [];
    const isDivisionTimeEnabled = JSON.parse(
      localStorage.getItem("deniedAppointments")
    )?.whiteshop?.isDivisionTimeEnabled;
    console.log("initial grp", groupsList);
    groupsList.forEach((grp) => {
      let divIndex;
      if (divisions.length) {
        divIndex = divisions.findIndex((div) => div._id === grp.division._id);
      } else {
        divIndex = -1;
      }
      let blockedAppointment = deniedAppointments.findIndex(
        (appId) => appId === grp.code
      );
      if (divIndex > -1) {
        if (divisions[divIndex].availability === "Unavailable") {
          divisions[divIndex].availability = grp.status;
          if (blockedAppointment !== -1) {
            divisions[divIndex]["availability"] = "Unavailable";
          }
        }
        if (grp.division.duration && isDivisionTimeEnabled) {
          if (
            !this.isCurrentTimeActive(
              nowTime,
              grp.division.duration.fromTime,
              grp.division.duration.toTime
            )
          ) {
            divisions[divIndex].availability = "Unavailable";
          }
        }
      } else {
        if (
          !grp.division.deleted &&
          !grp.division.disabled &&
          grp.owner.businessUnit
        ) {
          console.log("adding divisions ", grp.division);
          divisions.push(grp.division);
          if (divisions.length - 1 === 0) {
            divisions[divisions.length - 1]["inView"] = true;
          } else {
            divisions[divisions.length - 1]["inView"] = false;
          }
          divisions[divisions.length - 1]["availability"] = grp.status;
          if (blockedAppointment !== -1) {
            divisions[divisions.length - 1]["availability"] = "Unavailable";
          }
          if (grp.division.duration && isDivisionTimeEnabled) {
            if (
              !this.isCurrentTimeActive(
                nowTime,
                grp.division.duration.fromTime,
                grp.division.duration.toTime
              )
            ) {
              divisions[divisions.length - 1].availability = "Unavailable";
            }
          }
        }
      }
    });
    divisions = OrderByPipe.prototype.transform(divisions, ["availability"]);

    return divisions;
  }

  openWidget(domainKey) {
    const config = JSON.parse(localStorage.getItem("companyConfig"));
    let currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    if (!params.get("showIframe") || !params.get("openWidgetInPromolink")) {
      history.pushState(
        null,
        null,
        `${window.location.href}&showIframe=true&openWidgetInPromolink=true`
      );
    }
    if (!JSON.parse(localStorage.getItem("openWidgetInPromolink"))) {
      localStorage.setItem("openWidgetInPromolink", "true");
    }
    var script = document.createElement("script");
    script.id = "widgetc2cKey";
    let keyText = `window.c2cKey = ${domainKey};`;
    script.innerText = keyText;
    document.head.appendChild(script);
    var script1 = document.createElement("script");
    script1.id = "widgetJsFile";
    script1.src = `https://c2c-sc.s3.ap-south-1.amazonaws.com/c2c${
      c2cEnv[environment.name]
    }.js`;
    document.head.appendChild(script1);
  }
  setCartInventoryGroupData(product) {
    if (product.inventoryGroup?.gallery?.images?.length) {
      product.inventories.forEach((eachInventory) => {
        if (eachInventory.inventory?.gallery?.images) {
          eachInventory.inventory.gallery.images =
            product.inventoryGroup.gallery.images;
        }
        eachInventory.manageStock = product?.inventoryGroup?.manageStock;
        eachInventory.allowOutOfStockPurchase =
          product?.inventoryGroup?.allowOutOfStockPurchase;
      });
    }
  }
}
